'use strict';

const { displayTime } = require('../view-utils');

class DashboardView {
  constructor(api) { this.api = api; this.loaded = false; }
  show() { document.getElementById('dashboard-view').classList.remove('hidden'); if (!this.loaded) this.load(); }
  hide() { document.getElementById('dashboard-view').classList.add('hidden'); }
  bind() { document.getElementById('refresh-dashboard').addEventListener('click', () => this.load()); }
  async load() {
    const grid = document.getElementById('metric-grid');
    grid.innerHTML = '<div class="panel metric-card">正在加载指标…</div>';
    try {
      const data = await this.api.dashboard();
      const metrics = [
        ['累计注册', data.totalRegisteredPlayers], ['今日活跃', data.activePlayersToday],
        ['有效对局', data.validRuns], ['通关率', `${(data.clearRate * 100).toFixed(1)}%`],
        ['D1 留存', `${(data.d1Retention.rate * 100).toFixed(1)}%`], ['D7 留存', `${(data.d7Retention.rate * 100).toFixed(1)}%`],
        ['日榜参与', data.dailyLeaderboardParticipants], ['周榜参与', data.weeklyLeaderboardParticipants]
      ];
      grid.innerHTML = metrics.map(([label, value]) => `<div class="panel metric-card"><small>${label}</small><strong>${value}</strong></div>`).join('');
      document.getElementById('dashboard-generated').textContent = `统计截止：${displayTime(data.generatedAt)}（服务端最多缓存 60 秒）`;
      this.loaded = true;
    } catch (error) { grid.innerHTML = `<div class="panel metric-card">${error.message}</div>`; }
  }
}

module.exports = DashboardView;
